/** Converter for Square tenders <-> Paytronix tenders. */
export class TenderItemsConverter {
  /**
   * Converts Square tender items to Paytronix tender items.
   * @param tender Square tender items.
   * @returns Paytronix tender items.
   */
  static squareToPaytronix(tenders) {
    return tenders.map((tender) => {
      return {
        type: 'tenderItem',
        itemId: tender.type ?? '',
        name: tender.note ?? '',
        amount: Number(tender.amountMoney?.amount ?? 0) / 100,
      };
    });
  }
}
